<template>
  <div class="bottom-nav">
    <div class="like-button" :class="{ liked: isLiked }" @click="handleLike">
      <i :class="['far', 'fa-heart', { 'fas': isLiked }]"></i>
    </div>
    <button class="cook-button" @click="handleCook">
      <i class="fas fa-utensils"></i> 開始烹飪
    </button>
  </div>
</template>

<script>
export default {
  name: 'RecipeBottomNav',
  props: {
    isLiked: {
      type: Boolean,
      default: false
    }
  },
  emits: ['like', 'cook'],
  methods: {
    handleLike() {
      this.$emit('like')
    },
    handleCook() {
      this.$emit('cook')
    }
  }
}
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--card-background);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.like-button {
  color: var(--text-secondary);
  font-size: 1.5rem;
  cursor: pointer;
  transition: color 0.3s ease;
}

.like-button.liked {
  color: #F44336;
}

.cook-button {
  background: var(--primary);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 24px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.cook-button:hover {
  background: var(--primary-dark);
}
</style>